import {
  Button,
  Card,
  Col,
  Row,
  Spin,
  Table,
  Modal,
  Form,
  Input,
  DatePicker,
  Menu,
  Tooltip,
  Dropdown,
  Select,
  message,
  Pagination,
  Image,
} from "antd";
import { RiAddBoxFill } from "react-icons/ri";
import { useContext, useEffect, useRef, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import {
  addResignation,
  getSingleResignation,
  getAllResignation,
  updateResignation,
  getallDeveloper,
  getallDeveloperForTask,
  deleteResignation,
  getRawDataLog,
  deleteResignationSummary,
  deleteResignationDocument,
} from "../../utils/API";
import {
  FaFilePowerpoint,
  FaFileWord,
  FaPen,
  FaTrashAlt,
} from "react-icons/fa";
import { hasPermission } from "../../utils/HasPermission";
import AddResignationModal from "./Add";
import EditResignationModal from "./Edit";
import {
  ClockCircleOutlined,
  DeleteOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../../Auth/AuthContext";
import { autoRegisterCurrentPageColumns } from "../../utils/emailTemplateColumns";

const { Option } = Select;

interface Resignation {
  _id: string;
}

const Index = () => {
  const { authData } = useContext(AuthContext);
  const isAdmin = authData.roleId?.roleId === 1;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [currentResignationId, setcurrentResignationId] = useState<any>(null);
  const [form] = Form.useForm();
  const [developer, setDeveloper] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  const [page, setPage] = useState();
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [currentLogId, setCurrentLogId] = useState<string | null>(null);
  const [selectedLogs, setSelectedLogs] = useState<any[]>([]);
  const [isDocModalVisible, setIsDocModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<Resignation[] | any>([]);
  const [selectedDocs, setSelectedDocs] = useState<{ attachments?: string[] }>(
    {},
  );

  const [logsPagination, setLogsPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [logLoading, setLogLoading] = useState(false);
  const [logSearchText, setLogSearchText] = useState("");
  const modalScrollRef = useRef<HTMLDivElement>(null);

  const [SummaryModalOpen, setSummaryModalOpen] = useState(false);
  const [SummaryLoading, setSummaryLoading] = useState(false);
  const [SummaryData, setSummaryData] = useState<any[]>([]);
  const [CurrentSummaryDataId, setCurrentSummaryDataId] = useState<any>("");
  const [CurrentSingleSummaryDataId, setCurrentSingleSummaryDataId] =
    useState<any>("");

  const [newSummary, setNewSummary] = useState<{
    date: Dayjs | null;
    description: string;
  }>({
    date: dayjs(),
    description: "",
  });
  const [searchText, setSearchText] = useState("");
  const statusStyles: { [key: string]: string } = {
    Pending: "bg-yellow-100 text-yellow-800",
    Approved: "bg-green-100 text-green-800",
    Rejected: "bg-red-100 text-red-800",
  };

  const changeStatus = async (id: string, value: string) => {
    try {
      setLoading(true);
      await updateResignation(id, { status: value });
      setData((prev) =>
        prev.map((item) =>
          item._id === id ? { ...item, status: value } : item,
        ),
      );
    } catch (error) {
      console.error("Error updating resignation:", error);
    } finally {
      setLoading(false);
    }
  };

  const editResignation = (record: any) => {
    setIsEditModalVisible(true);
    setcurrentResignationId(record);
  };

  const handleViewLogs = async (Id: string, page = 1, search = "") => {
    try {
      setCurrentLogId(Id);
      setIsLogModalOpen(true);
      setLogLoading(true);
      let type = "Resignation";

      const data = await getRawDataLog(
        Id,
        page,
        logsPagination.pageSize,
        search,
        type,
      );

      setSelectedLogs(data.logs);
      setLogsPagination((prev) => ({
        ...prev,
        current: page,
        total: data.pagination.total,
        pageSize: data.pagination.pageSize,
      }));

      // scroll to top of modal
      setTimeout(() => {
        modalScrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    } catch (error) {
      console.error("Failed to fetch  logs:", error);
    } finally {
      setLogLoading(false);
    }
  };
  useEffect(() => {
    if (!currentLogId) return;

    const timeout = setTimeout(() => {
      handleViewLogs(currentLogId, 1, logSearchText);
    }, 400); // run after 400ms pause

    return () => clearTimeout(timeout);
  }, [logSearchText, currentLogId]);

  const handleViewSummary = async (recordId: any) => {
    setCurrentSummaryDataId(recordId._id);
    setCurrentSingleSummaryDataId(recordId.developerId);
    setSummaryModalOpen(true);
    setSummaryLoading(true);

    try {
      // ✅ Use your API function
      const res = await getSingleResignation(recordId.developerId);
      console.log(res);
      // assuming summaries are stored in `res.data.summaries`
      setSummaryData(res?.data?.resignation?.Summary || []);
    } catch (err) {
      console.error("Error fetching summary:", err);
      setSummaryData([]);
    } finally {
      setSummaryLoading(false);
    }
  };

  const renderDocuments = (
    title: string,
    docs?: string[],
    onDelete?: (doc: string) => void,
  ) => {
    if (!docs || docs.length === 0) {
      return null;
    }

    return (
      <div style={{ flex: 1, minWidth: "0" }}>
        <h3 style={{ margin: "0 0 12px", fontSize: "16px", fontWeight: 600 }}>
          {title}
        </h3>
        <div
          style={{
            display: "flex",
            gap: "20px",
            overflowX: "auto",
            paddingBottom: "10px",
            whiteSpace: "nowrap",
          }}
        >
          {docs.map((doc, index) => {
            const url = doc.startsWith("http")
              ? doc
              : `${process.env.REACT_APP_IMAGE_URL}/resignation/${doc}`;

            const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(doc);
            const isPdf = /\.pdf$/i.test(doc);
            const isWord = /\.(doc|docx)$/i.test(doc);
            const isPpt = /\.(ppt|pptx)$/i.test(doc);

            return (
              <div
                key={index}
                style={{
                  position: "relative",
                  border: "1px solid #eee",
                  borderRadius: "10px",
                  padding: "16px",
                  width: "260px",
                  flex: "0 0 auto",
                  textAlign: "center",
                  boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
                  background: "#fff",
                  cursor: isImage ? "default" : "pointer",
                }}
                onClick={() => {
                  if (!isImage) {
                    window.open(url, "_blank");
                  }
                }}
              >
                {onDelete && (
                  <DeleteOutlined
                    onClick={(e) => {
                      e.stopPropagation(); // prevent triggering open
                      onDelete(doc);
                    }}
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      color: "red",
                      cursor: "pointer",
                      fontSize: "18px",
                    }}
                  />
                )}

                {isImage ? (
                  <Image
                    src={url}
                    alt={`Document ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      marginBottom: "10px",
                    }}
                    preview={true}
                  />
                ) : isPdf ? (
                  <div
                    style={{
                      fontSize: "80px",
                      color: "red",
                      marginBottom: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "180px",
                    }}
                  >
                    <FilePdfOutlined />
                  </div>
                ) : isWord ? (
                  <div
                    style={{
                      fontSize: "80px",
                      color: "#2B579A",
                      marginBottom: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "180px",
                    }}
                  >
                    <FaFileWord />
                  </div>
                ) : isPpt ? (
                  <div
                    style={{
                      fontSize: "80px",
                      color: "#D24726",
                      marginBottom: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "180px",
                    }}
                  >
                    <FaFilePowerpoint />
                  </div>
                ) : (
                  <div
                    style={{
                      fontSize: "70px",
                      color: "#999",
                      marginBottom: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "180px",
                    }}
                  >
                    <FileOutlined />
                  </div>
                )}

                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    margin: 0,
                    wordBreak: "break-word",
                  }}
                >
                  {doc.split("/").pop()}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const handleDeletedocument = async (doc: string, resignationId: string) => {
    try {
      await deleteResignationDocument(resignationId, doc); // doc is your documentName
      message.success("Document deleted successfully");

      getAllResignation();
      // Update UI
      setSelectedDocs((prev: any) => ({
        attachments: prev.attachments?.filter((d: any) => d !== doc),
      }));
    } catch (error: any) {
      console.error(error);
      message.error(
        error?.response?.data?.message || "Failed to delete document",
      );
    }
  };

  const columns = [
    {
      title: "#",
      key: "index",
      fixed: "left" as const,
      width: 60,
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      fixed: "left" as const,
    },
    {
      title: "Applied Date",
      dataIndex: "date",
      key: "date",
      align: "center" as const,
      fixed: "left" as const,

      render: (date: string | Date) =>
        date ? dayjs(date).format("DD-MM-YYYY") : "-",
    },
    {
      title: "Approved Date",
      dataIndex: "approvedDate",
      key: "approvedDate",
      align: "center" as const,
      fixed: "left" as const,
      render: (date: string | undefined) => (date ? date : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center" as const,
      render: (status: string, record: any) => {
        const getStatusBadge = (value: string) => (
          <span className={`badge rounded-pill ${statusStyles[value]}`}>
            {value}
          </span>
        );

        if (isAdmin) {
          const items = ["Pending", "Approved", "Rejected"].map((item) => ({
            key: item,
            label: getStatusBadge(item),
          }));
          return (
            <Dropdown
              menu={{
                items,
                onClick: ({ key }) => changeStatus(record._id, key),
              }}
              trigger={["click"]}
            >
              <span className="cursor-pointer">{getStatusBadge(status)}</span>
            </Dropdown>
          );
        }

        return status === "Rejected" && record.remarks ? (
          <Tooltip
            title={record.remarks}
            placement="top"
            overlayInnerStyle={{
              backgroundColor: "#fff",
              color: "#000",
              borderRadius: "8px",
              padding: "8px 12px",
              fontSize: "14px",
              fontWeight: 500,
              maxWidth: "240px",
              whiteSpace: "normal",
              textAlign: "center",
            }}
            color="#CCCCCC"
          >
            <span>{getStatusBadge(status)}</span>
          </Tooltip>
        ) : (
          getStatusBadge(status)
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text?: string) => {
        if (!text) return <div className="text-gray-400">N/A</div>;
        const maxWords = 3;
        const words = text.split(" ");
        const shortText =
          words.length > maxWords
            ? words.slice(0, maxWords).join(" ") + "..."
            : text;
        return words.length > maxWords ? (
          <Tooltip
            title={text}
            placement="top"
            color="#CCCCCC"
            overlayInnerStyle={{ color: "#000", padding: "12px" }}
          >
            <div className="text-gray-800 hover:text-black cursor-pointer">
              {shortText}
            </div>
          </Tooltip>
        ) : (
          <div className="text-gray-800">{shortText}</div>
        );
      },
    },
    ...(isAdmin
      ? [
          {
            title: "Documents",
            key: "documents",
            render: (_: any, record: any) => (
              <button
                className="w-7 h-7 rounded-full bg-gradient-to-br from-rose-500 to-rose-700 shadow-[0_4px_12px_rgba(244,63,94,0.3)] hover:shadow-[0_6px_16px_rgba(244,63,94,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
                onClick={() => {
                  setCurrentRecord(record);
                  setSelectedDocs({ attachments: record.attachments || [] });
                  setIsDocModalVisible(true);
                }}
              >
                <FileTextOutlined />
              </button>
            ),
          },
          {
            title: "Summary",
            key: "summary",
            render: (_: any, record: any) => (
              <Tooltip title="View Summary">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewSummary(record);
                  }}
                  className="w-7 h-7 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 shadow-[0_4px_12px_rgba(16,185,129,0.3)] hover:shadow-[0_6px_16px_rgba(16,185,129,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="group-hover:scale-110 transition-transform"
                  >
                    <path
                      d="M4 6H20M4 12H20M4 18H11"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </Tooltip>
            ),
          },
          {
            title: "Logs",
            key: "JobApplicationLog",
            render: (_: any, record: any) => (
              <Tooltip title="View Logs">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewLogs(record._id);
                  }}
                  className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-400 to-blue-600 shadow-[0_4px_12px_rgba(96,165,250,0.3)] hover:shadow-[0_6px_16px_rgba(96,165,250,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="group-hover:scale-110 transition-transform"
                  >
                    <path
                      d="M6 4V20M18 4V20M6 4H18M6 20H18M9 8H15M9 12H15M9 16H13"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </Tooltip>
            ),
          },
          {
            title: "Action",
            dataIndex: "action",
            render: (_: any, record: any) => (
              <div
                className="d-flex"
                style={{ gap: "8px", alignItems: "center" }}
              >
                {hasPermission("resignation", "update") && (
                  <Tooltip title="Edit">
                    <button
                      onClick={() => editResignation(record)}
                      className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 shadow-[0_4px_12px_rgba(139,92,246,0.3)] hover:shadow-[0_6px_16px_rgba(139,92,246,0.4)] active:translate-y-[1px] active:shadow-none text-white flex items-center justify-center transition-all duration-200 ease-in-out group"
                    >
                      <FaPen
                        className="group-hover:scale-110 transition-transform duration-200"
                        size={12}
                      />
                    </button>
                  </Tooltip>
                )}
                {hasPermission("resignation", "delete") && (
                  <Tooltip title="Delete">
                    <button
                      onClick={() => {
                        setDeleteModal(true);
                        setDeleteId(record._id);
                      }}
                      className="w-7 h-7 rounded-full bg-gradient-to-br from-rose-500 to-rose-700 shadow-[0_4px_12px_rgba(244,63,94,0.3)] hover:shadow-[0_6px_16px_rgba(244,63,94,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
                    >
                      <FaTrashAlt
                        className="group-hover:scale-110 transition-transform"
                        size={12}
                      />
                    </button>
                  </Tooltip>
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  useEffect(() => {
    autoRegisterCurrentPageColumns(columns);
  }, []);

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const getAuthData = () => {
    const authDataString = localStorage.getItem("authData");
    const existingAuthData = authDataString ? JSON.parse(authDataString) : null;
    if (existingAuthData?.user) {
      setDeveloper(existingAuthData.user);
      if (existingAuthData.user?.roleId?.name === "Admin") {
        getAllResignations();
        getAllUsersData();
      } else {
        getSingleResignationData(existingAuthData.user._id);
      }
    }
  };

  const getSingleResignationData = async (userId: string) => {
    try {
      setLoading(true);
      const response = await getSingleResignation(userId);
      let resignationData = response?.data?.resignation;
      if (resignationData && !Array.isArray(resignationData)) {
        resignationData = [resignationData];
      }
      setData(resignationData || []);
    } catch (error) {
      console.error("Error getting resignation:", error);
    } finally {
      setLoading(false);
    }
  };

  const getAllResignations = async () => {
    try {
      setLoading(true);
      const response = await getAllResignation();
      let resignationData = response?.data?.resignations;
      if (resignationData && !Array.isArray(resignationData)) {
        resignationData = [resignationData];
      }
      setData(resignationData || []);
    } catch (error) {
      console.error("Error getting all resignations:", error);
    } finally {
      setLoading(false);
    }
  };

  const getAllUsersData = async () => {
    try {
      const response = await getallDeveloperForTask(searchText, page);
      setUsers(response?.data || []);
    } catch (error) {
      console.error("Error getting all users:", error);
    }
  };

  useEffect(() => {
    getAuthData();
  }, []);

  const handleDelete = async () => {
    if (deleteId) {
      try {
        const res = await deleteResignation(deleteId);
        if (res?.status === 200) {
          message.success("Resignation deleted successfully");
          getAllResignations(); // refetch or update state
          setDeleteModal(false);
        } else {
          message.error("Failed to delete resignation");
        }
      } catch (error) {
        message.error("Something went wrong");
        console.error(error);
      }
    }
  };

  return (
    <div>
      <Row className="m-2" gutter={[16, 16]} align="middle">
        <Col xs={24} sm={24} md={6}>
          <h2 style={{ fontSize: "20px", fontWeight: 600, margin: 0 }}>
            Resignation
          </h2>
        </Col>
        <Col xs={24} sm={24} md={18}>
          <div
            style={{
              display: "flex",
              gap: 16,
              justifyContent: "flex-end",
              height: "33px",
            }}
          >
            <Button
              type="primary"
              style={{ background: "#001529", height: "33px" }}
              onClick={handleOpenModal}
            >
              <RiAddBoxFill className="button-icon" />
              <span className="button-text">Apply For Resignation</span>
            </Button>
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Card className="w-100">
            <Spin spinning={loading}>
              <div className="scrollbar-hide custom-scroll-table">
                <Table
                  columns={columns}
                  dataSource={data}
                  rowKey="_id"
                  scroll={{ x: "max-content" }}
                  loading={loading}
                />
              </div>
            </Spin>
          </Card>
        </Col>
      </Row>

      <Modal
        open={deleteModal}
        onOk={handleDelete}
        onCancel={() => setDeleteModal(false)}
        okText="Yes"
        cancelText="No"
        width={500}
        centered={false}
        destroyOnClose
        className="custom-modal"
        style={{
          bottom: 20,
          top: "10vw",
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        title={
          <div
            style={{
              marginLeft: "11px",
              width: "100%",
              paddingRight: 20,
            }}
          >
            Confirmation
          </div>
        }
        okButtonProps={{
          style: {
            backgroundColor: "#ff4d4f",
            borderColor: "#ff4d4f",
            color: "white",
          },
        }}
        bodyStyle={{
          padding: "22px",
          overflowY: "auto",
          fontFamily: "inter, sans-serif",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
          footer: {
            borderTop: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
        }}
      >
        <p>Are you sure you want to delete this Resignation ?</p>
      </Modal>
      <Modal
        title={
          <div className="flex justify-between items-center w-full">
            <span className="text-xl font-bold">Resignation Log</span>
            <Input
              placeholder="🔍 Search logs..."
              allowClear
              value={logSearchText}
              onChange={(e) => setLogSearchText(e.target.value)}
              className="w-64 rounded text-sm mr-10"
            />
          </div>
        }
        open={isLogModalOpen}
        onCancel={() => setIsLogModalOpen(false)}
        footer={null}
        width={650}
        style={{
          bottom: 20,
          top: 20,
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        styles={{
          body: {
            overflowY: "auto",
            fontFamily: "inter, sans-serif",
          },
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <Spin spinning={logLoading}>
          <div ref={modalScrollRef} className="">
            <div className="elements">
              <table className="w-full bg-white shadow-md rounded-lg">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-3 text-left w-1/3">
                      <ClockCircleOutlined className="mr-2" /> Updated At
                    </th>
                    <th className="border p-3 text-left">
                      <MessageOutlined className="mr-2" /> Message
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {selectedLogs.length > 0 ? (
                    selectedLogs.map((log) => {
                      const formattedTimestamp = dayjs(log.createdAt)
                        .utc()
                        .local()
                        .format("DD-MM-YYYY HH:mm");

                      return (
                        <tr
                          key={log._id}
                          className="hover:bg-gray-100 transition"
                        >
                          <td className="border p-3">{formattedTimestamp}</td>
                          <td className="border p-3 max-w-xl">
                            {(() => {
                              const maxWords = 12; // set your threshold
                              const words = log.message.split(" ");
                              const isLong = words.length > maxWords;
                              const displayText = isLong
                                ? words.slice(0, maxWords).join(" ") + "..."
                                : log.message;

                              return isLong ? (
                                <Tooltip
                                  title={log.message}
                                  placement="topLeft"
                                  color="#CCCCCC"
                                  overlayInnerStyle={{
                                    color: "#000",
                                    padding: "12px",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "-webkit-box",
                                      // WebkitBoxOrient: "vertical" as const,
                                      // WebkitLineClamp: 2,
                                      // overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                      maxWidth: "350px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {displayText}
                                  </span>
                                </Tooltip>
                              ) : (
                                <span
                                  style={{
                                    display: "-webkit-box",
                                    // WebkitBoxOrient: "vertical" as const,
                                    // WebkitLineClamp: 2,
                                    // overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    maxWidth: "350px",
                                  }}
                                >
                                  {displayText}
                                </span>
                              );
                            })()}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={2}
                        className="border p-3 text-center text-gray-500"
                      >
                        No logs available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="footer-modals" />
            <div className="p-3">
              <div className="d-flex justify-content-end">
                <Pagination
                  current={logsPagination.current}
                  pageSize={logsPagination.pageSize}
                  total={logsPagination.total}
                  onChange={(page) => {
                    if (currentLogId) {
                      handleViewLogs(currentLogId, page, logSearchText);
                    }
                  }}
                  showSizeChanger={false}
                />
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
      <Modal
        title={
          <div className="flex justify-between items-center w-full">
            <span className="text-xl font-bold">Summary</span>
          </div>
        }
        open={SummaryModalOpen}
        onCancel={() => setSummaryModalOpen(false)}
        footer={null}
        width={650}
        style={{
          bottom: 20,
          top: 20,
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          body: {
            overflowY: "auto",
            fontFamily: "inter, sans-serif",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <Spin spinning={SummaryLoading}>
          <div className="elements">
            <table className="w-full bg-white shadow-md rounded-lg">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2 text-left w-[21%]">
                    <ClockCircleOutlined className="mr-2" /> Date
                  </th>
                  <th className="border p-2 text-left">
                    <MessageOutlined className="mr-2" /> Summary
                  </th>
                  <th className="border p-2 text-left w-[10%]">Action</th>
                </tr>
              </thead>
              <tbody>
                {SummaryData.length > 0 ? (
                  SummaryData.map((Summary, idx) => (
                    <tr key={idx} className="hover:bg-gray-100 transition">
                      <td className="border p-2">{Summary.date}</td>
                      <td className="border p-2">
                        {(() => {
                          const description = Summary.description || ""; // fallback to empty string
                          const maxWords = 18;
                          const words = description.split(" ");
                          const isLong = words.length > maxWords;
                          const displayText = isLong
                            ? words.slice(0, maxWords).join(" ") + "..."
                            : description;

                          const commonStyle = {
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical" as const,
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            wordBreak: "break-word" as any, // bypass TS check
                            maxWidth: "405px",
                            cursor: isLong ? "pointer" : "default",
                          };

                          return isLong ? (
                            <Tooltip
                              title={description}
                              color="#CCCCCC"
                              overlayInnerStyle={{
                                color: "#000",
                                padding: "8px",
                              }}
                            >
                              <span style={commonStyle}>{displayText}</span>
                            </Tooltip>
                          ) : (
                            <span style={commonStyle}>{displayText}</span>
                          );
                        })()}
                      </td>

                      <td className="border p-2 text-center">
                        <DeleteOutlined
                          className="text-red-500 cursor-pointer hover:text-red-700"
                          onClick={async () => {
                            try {
                              setSummaryLoading(true);
                              await deleteResignationSummary(
                                CurrentSummaryDataId,
                                Summary._id,
                              );
                              message.success("Summary deleted successfully");
                              const res = await getSingleResignation(
                                CurrentSingleSummaryDataId,
                              );
                              setSummaryData(
                                res?.data?.resignation?.Summary || [],
                              );
                            } catch (err: any) {
                              message.error(
                                err.response?.data?.message ||
                                  "Error deleting Summary",
                              );
                            } finally {
                              setSummaryLoading(false);
                            }
                          }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center p-4 text-gray-500">
                      No Description found
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="border p-2">
                    <DatePicker
                      value={newSummary.date}
                      format={"DD-MM-YYYY"}
                      onChange={(val) =>
                        setNewSummary({ ...newSummary, date: val })
                      }
                      style={{ width: "100%" }}
                    />
                  </td>
                  <td className="border p-2">
                    <Input.TextArea
                      rows={1}
                      placeholder="Enter description..."
                      value={newSummary.description}
                      onChange={(e) =>
                        setNewSummary({
                          ...newSummary,
                          description: e.target.value,
                        })
                      }
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="flex justify-end mt-3">
            <Button
              className="allbuttons"
              style={{
                color: "white",
                marginBottom: "10px",
                marginRight: "5px",
              }}
              onClick={async () => {
                if (!newSummary.description?.trim()) {
                  return message.error("Please enter a Summary");
                }
                try {
                  setSummaryLoading(true);
                  await updateResignation(CurrentSummaryDataId, {
                    newSummary: {
                      description: newSummary.description,
                      date: newSummary.date?.format("DD-MM-YYYY"),
                    },
                  });
                  message.success("Summary added successfully");
                  const res = await getSingleResignation(
                    CurrentSingleSummaryDataId,
                  );
                  setSummaryData(res?.data?.resignation?.Summary || []);
                  setNewSummary({ date: dayjs(), description: "" });
                } catch (err: any) {
                  message.error(
                    err.response?.data?.message || "Error adding Summary",
                  );
                } finally {
                  setSummaryLoading(false);
                }
              }}
            >
              Add Summary
            </Button>
          </div>
        </Spin>
      </Modal>
      <AddResignationModal
        visible={isModalVisible}
        onCancel={handleCancel}
        refreshData={() => {
          if (!developer) return; // don't call if developer not loaded
          return developer.roleId?.name === "Admin"
            ? getAllResignations()
            : getSingleResignationData(developer._id);
        }}
      />

      <EditResignationModal
        visible={isEditModalVisible}
        onCancel={() => setIsEditModalVisible(false)}
        onUpdate={() => setIsEditModalVisible(false)}
        currentResignationId={currentResignationId}
        refreshData={getAllResignations}
      />
      {/* Document Modal */}
      <Modal
        open={isDocModalVisible}
        onCancel={() => setIsDocModalVisible(false)}
        footer={null}
        width={800}
        className="custom-modal"
        style={{
          bottom: 20,
          top: 20,
          height: "60vh",
          margin: "0 auto",
          position: "relative",
        }}
        title={
          <div
            style={{
              marginLeft: "11px",
              width: "100%",
              paddingRight: 20,
            }}
          >
            Documents
          </div>
        }
        bodyStyle={{
          overflowY: "auto",
          fontFamily: "inter, sans-serif",
          height: "calc(100% - 55px)",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <div className="elements">
          {selectedDocs &&
          selectedDocs.attachments &&
          selectedDocs.attachments.length > 0 ? (
            <div
              style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
            >
              {renderDocuments(
                "Attachments",
                selectedDocs.attachments,
                (doc: any) =>
                  handleDeletedocument(doc, currentRecord._id || ""),
              )}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                minHeight: "200px",
                color: "rgba(0,0,0,0.45)",
              }}
            >
              <FileOutlined style={{ fontSize: "24px", marginRight: "8px" }} />
              No documents available
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export const RESIGNATION_TABLE_COLUMNS = [
  "name",
  "date",
  "approvedDate",
  "status",
  "description",
];

export default Index;
